import request from '../../request'
import {questions} from '../../endpoints'

export default class categoriesApi {
  static async getForBuilder({matId, schoolId, surveyId, search}) {
    return request({
      url: questions.getBuilderCategories(matId, schoolId, surveyId, search),
      method: 'GET',
    })
  }

  static async create({name, matId, schoolId, source = null, templateId = null}) {
    return request({
      url: questions.createCategory(),
      method: 'POST',
      data: {
        name,
        matId,
        schoolId,
        source,
        templateId,
      },
    })
  }
}
